import { __decorate } from "tslib";
import fetchFromCache from '@/utilities/fetchFromCache';
import { Module, VuexModule, MutationAction } from 'vuex-module-decorators';
let Deployments = class Deployments extends VuexModule {
    constructor() {
        super(...arguments);
        this.deployments = [];
        this.cachedVersion = 0;
    }
    async fetchDeployments() {
        const { data: deployments, cachedVersion } = await fetchFromCache(this, 'deployments', 'StarshipDeployment');
        return { deployments, cachedVersion };
    }
};
__decorate([
    MutationAction({ mutate: ['deployments', 'cachedVersion'] })
], Deployments.prototype, "fetchDeployments", null);
Deployments = __decorate([
    Module({ namespaced: true, name: 'deployments' })
], Deployments);
export default Deployments;
